/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Address } from './Address';
import { OrderItem } from './OrderItem';
export interface Order {
    /**
     * globally unique id
     */
    id?: string;

    /**
     * for DUES_NEW or DUES_RENEW orders, the start date of the year covered by the dues
     */
    startDate?: string;

    /**
     * created by user id
     */
    createId?: string;

    /**
     * created timestamp
     */
    createAt?: string;

    /**
     * account id of order
     */
    accountId?: string;

    /**
     * entity id of order
     */
    entityId?: string;

    /**
     * internal note
     */
    note?: string;

    /**
     * amount offset in adjustments
     */
    adjustmentAmount?: number;

    /**
     * human-readable auto-incrementing order number
     */
    number?: number;

    /**
     * current status of order
     */
    status?: Order.Status;

    /**
     * amount billed
     */
    billAmount?: number;

    /**
     * billing address
     */
    billingAddress?: Address;

    /**
     * shipping address
     */
    shippingAddress?: Address;

    /**
     * amount refunded
     */
    refundAmount?: number;

    /**
     * items purchased in order
     */
    items?: Array<OrderItem>;

    /**
     * amount paid
     */
    paymentAmount?: number;

    /**
     * entity type of order
     */
    entityType?: Order.EntityType;

    /**
     * category of order
     */
    category?: Order.Category;

    /**
     * type of payment
     */
    transactionType?: Order.TransactionType;

    /**
     * amount disbursed
     */
    disbursementAmount?: number;

    /**
     * memo that will appear on invoice
     */
    memo?: string;

    /**
     * timestamp of order
     */
    at?: number;

    /**
     * last status update
     */
    lastStatusUpdate?: string;
}

export namespace Order {

    export enum Status {
            PENDING = <any> 'PENDING',
            PAID = <any> 'PAID',
            CANCELLED = <any> 'CANCELLED'
    }
    export enum EntityType {
            MEMBER = <any> 'MEMBER',
            USER = <any> 'USER',
            ORG = <any> 'ORG',
            PHOTO = <any> 'PHOTO'
    }
    export enum Category {
            DUES_NEW = <any> 'DUES_NEW',
            DUES_RENEW = <any> 'DUES_RENEW',
            LOCATIONS = <any> 'LOCATIONS',
            CERT_NEW = <any> 'CERT_NEW',
            CERT_RENEW = <any> 'CERT_RENEW',
            OTHER = <any> 'OTHER'
    }
    export enum TransactionType {
            CHARGE = <any> 'CHARGE',
            CHECK = <any> 'CHECK',
            WIRE = <any> 'WIRE',
            RECEIVABLE = <any> 'RECEIVABLE',
            REFUND_CHARGE = <any> 'REFUND_CHARGE',
            REFUND_CHECK = <any> 'REFUND_CHECK',
            CANCEL = <any> 'CANCEL',
            ADJUSTMENT = <any> 'ADJUSTMENT'
    }
}



// WEBPACK FOOTER //
// ./src/common/api/models/Order.ts